import { DialogContent, DialogOverlay } from '@reach/dialog';
import '@reach/dialog/styles.css';
import classNames from 'classnames';
import React, { useRef } from 'react';
import cls from './ModalR.module.scss';
import { CloseIcon } from '../../../../assets/images/new-icons';

export default function ModalR(props) {
    const { isOpen, onClose, onContentPress, id, hasCloseIcon, shadowedContainerClassname, allowClick } = props;
    const noFocusRef = useRef(null);

    const close = () => {
        onClose && onClose();
    };

    return (
        <>
            <DialogOverlay
                dangerouslyBypassFocusLock={props.dangerouslyBypassFocusLock || false}
                className={classNames(cls.transparent, { [cls.allowClick]: allowClick })}
                isOpen={isOpen}
                onDismiss={allowClick ? undefined : close} // Disable dismiss if allowClick is true
                id={id}
                style={{
                    ...props.modalWrapperStyle,
                    ...(allowClick ? { backgroundColor: 'transparent' } : {}), // Inline override for safety
                }}
                initialFocusRef={noFocusRef} // Direct focus to a non-focusable div
            >
                {/* Non-focusable div to capture initial focus */}
                <div
                    ref={noFocusRef}
                    tabIndex={-1}
                    style={{ position: 'absolute', opacity: 0, pointerEvents: 'none' }}
                />
                <DialogContent
                    onClick={onContentPress}
                    className={classNames(cls.host, shadowedContainerClassname)}
                    app-variant-opened={isOpen ? 'true' : 'false'}
                    style={{ ...props.shadowedContainerStyle }}
                    aria-label="Warning"
                >
                    {hasCloseIcon && (
                        <div className={cls.closeContainer} onClick={close}>
                            <CloseIcon onClick={close} />
                        </div>
                    )}
                    {props.children}
                </DialogContent>
            </DialogOverlay>
        </>
    );
}
